import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {Dog} from "../../../../../classes/dog";
import {kanDogDialog} from "../../../dialogs/dog-dialog/component";
import {kanDogsService} from "../../../../services/services/dogs";
import {kanMembershipDialog} from "../../../dialogs/membership-dialog/component";
import {kanFilesService} from "../../../../services/services/files";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-dog-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanDogListItem {
    @Input() dog: Dog;
    @Input() searchText: string;
    @Output() refresh: EventEmitter<any> = new EventEmitter();
    public toggled: boolean = false;
    public avatarPath: string;
    public selectedTab: number = 0;

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private dogsService: kanDogsService,
                private filesService: kanFilesService) {
    }

    ngOnInit(): void {
        if (this.dog.avatar) {
            this.avatarPath = `${this.dog.avatar.path}?${Date.now()}&&access_token=${this.authService.token}`;
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public toggle() {
        this.toggled = !this.toggled;
    }

    public goToDogDetail(event: any) {
        this.stateService.go('app.admin.dog', {id: this.dog.id});
    }

    public editDogDialog(event: any) {
        let dialogRef = this.dialog.open(kanDogDialog, {
            data: {
                user: this.dog.owner,
                dog: this.dog
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'update') {
                    this.refresh.emit();
                }
            });
    }

    public editMembershipDialog(event: any) {
        let dialogRef = this.dialog.open(kanMembershipDialog, {
            data: {
                user: this.dog.owner,
                dog: this.dog
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public setAvatar(event: any) {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.click();
        input.addEventListener('change', (e) => {
            let file = input.files[0];
            this.filesService.uploadFile('dogFiles', this.dog.id, file, this.dog.id, 'dog')
                .then((fileData) => {
                    this.dog.avatar = fileData;
                    this.dogsService.updateDog(this.dog)
                        .then(() => {
                            this.refresh.emit();
                        })
                        .catch((error) => {
                        });
                })
                .catch((error) => {
                });
        });
    }

    public removeDog(event) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.dogsService.removeDog(this.dog)
                    .then((data) => {
                        this.refresh.emit();
                    });
            }
        });
    }

    public tabChanged(index: number) {
        this.selectedTab = index;
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/list-item/component.ts